import { FC } from "react";

interface TabSelectorProps {
  activeTab: "staff" | "inventory";
  setActiveTab: (tab: "staff" | "inventory") => void;
}

export const TabSelector: FC<TabSelectorProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="bg-white rounded-lg border mb-6 shadow-sm">
      <div className="flex border-b">
        <button
          className={`px-6 py-3 font-medium ${
            activeTab === "staff"
              ? "text-blue-600 border-b-2 border-blue-600"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("staff")}
        >
          Staff
        </button>
        <button
          className={`px-6 py-3 font-medium ${
            activeTab === "inventory"
              ? "text-blue-600 border-b-2 border-blue-600"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("inventory")}
        >
          Inventory
        </button>
      </div>
    </div>
  );
};
